const body = document.querySelector("body");

function pageLinksHandler(e) {
    var dataAttr = "data-filter";
    var el_link = e.target.closest("a");

    if (el_link && el_link.hasAttribute(dataAttr)) {
        var filtersID = el_link.getAttribute(dataAttr);

        var filterContainer = document.querySelector(filtersID);
        var activeFilter = filterContainer.querySelector("[data-filter-group='state'] .uk-active .link-filter-title")
            || filterContainer.querySelector(".uk-active .link-filter-title");

        if (!activeFilter) {
            return;
        }

        el_link.href = `${el_link.getAttribute("href")}?filter=${
            activeFilter.textContent
        }`;
    }
}

export default {
    init: function () {
        //Filters pagination
        if (document.querySelectorAll("[class^='blocklink']").length > 0) {
            body.addEventListener("mousedown", pageLinksHandler);
        }
    },
    cleanup: function () {
        body.removeEventListener("mousedown", pageLinksHandler);
    }
};
